import script from "./SourceCardLink.vue?vue&type=script&setup=true&lang=js"
export * from "./SourceCardLink.vue?vue&type=script&setup=true&lang=js"

import "./SourceCardLink.vue?vue&type=style&index=0&id=7b20a971&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b20a971"]])

export default __exports__